// import PanelSnap from 'panelsnap';
// let researchPanel = null;

export default {
	namespace: 'research',
	beforeEnter(barba) {

		barba.next.container.querySelector('ul.nav').classList.add('fixed-nav');

	},
	afterEnter(barba) {

		const firstPanel = barba.next.container.querySelectorAll('.research-item-wrapper')[0]

		let counterEl = document.querySelector('.research-counter')
		const count = '_' + (parseInt(firstPanel.dataset.index) + 101)
		counterEl.innerHTML = count

		// inside .research-container there are a list of sections. I want to increase the counter every time a new section is in view

		const researchContainer = barba.next.container.querySelector('.research-container')
		const researchItems = barba.next.container.querySelectorAll('.research-item-wrapper')

		let currentPanel = 0

		window.addEventListener('scroll', () => {
			researchItems.forEach((item, index) => {
				const rect = item.getBoundingClientRect();
				if (rect.top <= 0) {
					if (currentPanel !== index) {
						currentPanel = index;
						const count = '_' + (index + 101);
						counterEl.innerHTML = count;
					}
				}
			});
		});


	},
	beforeLeave(barba) {

		barba.next.container.querySelector('ul.nav').classList.remove('fixed-nav');
		// researchPanel.destroy();

	},
	afterLeave() {

	}
}
